import { RefreshCw, WifiOff } from "lucide-react";
import { common } from "../copy/common";
import { errors } from "../copy/errors";
import { useConnectionState } from "../lib/online";

/** Slim banner at the very top while offline or reconnecting (UX_SPEC §0.3). */
export function OfflineBanner() {
  const state = useConnectionState();
  return (
    <div role="status" aria-live="polite">
      {state !== "online" && (
        <div className="flex items-center justify-center gap-2 bg-foreground px-4 py-1.5 text-center text-sm text-background">
          {state === "offline" ? (
            <WifiOff className="size-4 shrink-0" aria-hidden="true" />
          ) : (
            <RefreshCw className="size-4 shrink-0 animate-spin [animation-duration:2s] motion-reduce:animate-none" aria-hidden="true" />
          )}
          <span>{state === "offline" ? common.offlineBanner : errors.reconnectingBanner}</span>
        </div>
      )}
    </div>
  );
}
